import React from 'react';
import PropTypes from 'prop-types';
import { Radio, RadioGroup, FormControl, FormControlLabel, FormHelperText, InputLabel } from '@material-ui/core/';
import useStyles from './styles';

const CustomRadio = ({
  input: { name, value, onChange, onBlur, onFocus },
  customStyles,
  id,
  label,
  meta,
  disabled,
  ...rest
}) => {
  const classes = useStyles();
  const isError = meta.touched && !meta.valid;
  const selectedValue = (value ?? '').toString();

  return (
    <FormControl className={customStyles} component="fieldset" fullWidth={rest.fullWidth} error={isError}>
      <InputLabel className={classes.label} shrink htmlFor={id}>
        {label}
      </InputLabel>
      <RadioGroup
        className={classes.group}
        aria-label={name}
        name={name}
        value={selectedValue}
        onChange={(event, nextValue) => onChange(nextValue)}
        onBlur={onBlur}
        onFocus={onFocus}
      >
        {rest.items.map(item => (
          <FormControlLabel
            key={item.value}
            label={item.name}
            value={item.value}
            disabled={disabled}
            className={`${classes.radioLabel} ${item.value === selectedValue && classes.active}`}
            control={<Radio checked={item.value === selectedValue} />}
          />
        ))}
      </RadioGroup>
      {isError && (
        <FormHelperText id="outlined-weight-helper-text" error>
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

CustomRadio.defaultProps = {
  customStyles: undefined,
  disabled: false,
};

CustomRadio.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  }).isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape().isRequired,
  id: PropTypes.string.isRequired,
  customStyles: PropTypes.string,
  disabled: PropTypes.bool,
};

export default CustomRadio;
